// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".z-in{z-index:1000}.cookie-container{max-width:1308px;padding-left:15px;padding-right:15px;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
